import * as z from "zod/v4";

export const intercomGetAiChatResponse = {
  name: "intercomGetAiChatResponse" as const,
  input: z.object({
    userEmail: z.string(),
    userMessages: z.array(z.string()),
    orderNumber: z.string(),
  }),
  output: z.object({ message: z.string() }),
};
